/**
 * @generated SignedSource<<66474dbd2796df141bd06ebac84678df>>
 * @relayHash 3b300d9db15ab0bcc9e6fd4faf68fd66
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c1cea8ee89608e6a77d110730b741ce6aaabd0ad933c6c3505a14cb43e016ae6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { async_AsyncMenuContentQuery } from './async_AsyncMenuContentQuery.graphql';

const node: PreloadableConcreteRequest<async_AsyncMenuContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c1cea8ee89608e6a77d110730b741ce6aaabd0ad933c6c3505a14cb43e016ae6",
    "metadata": {},
    "name": "async_AsyncMenuContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
